import Icon from "./Icon";

const CREATE_OPTIONS = [
  { key: "inventory", title: "Inventory", helper: "Create new Product", icon: "box" },
  { key: "import", title: "Import", helper: "Products from file", icon: "import" },
  { key: "invoice", title: "Invoices", helper: "Generate new invoice", icon: "invoice" },
  { key: "supplier", title: "Supplier", helper: "Create a new supplier", icon: "store" },
  { key: "customer", title: "Customer", helper: "Create a new customer", icon: "userAdd" },
  { key: "report", title: "Report", helper: "Printable report", icon: "report" },
];

function CreateCard({ option, selected, onSelect }) {
  return (
    <button
      type="button"
      className={`create-card ${selected ? "selected" : ""}`}
      onClick={() => onSelect(option.key)}
      aria-pressed={selected}
    >
      <span className="create-card__icon">
        <Icon name={option.icon} />
      </span>
      <div>
        <div className="create-card__title">{option.title}</div>
        <div className="muted">{option.helper}</div>
      </div>
    </button>
  );
}

function CreateModal({ open, selectedKey, onSelect, onClose, onCreate, sideContent }) {
  if (!open) return null;

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose?.();
    }
  };

  const handleCreate = () => {
    if (!selectedKey) return;
    onCreate?.(selectedKey);
  };

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" aria-labelledby="create-modal-title" onClick={handleOverlayClick}>
      <div className="create-layer">
        <div className="create-modal">
          <header className="create-modal__header">
            <div className="create-modal__title">
              <span className="panel-icon soft">
                <Icon name="addSquare" />
              </span>
              <h2 id="create-modal-title">Create new</h2>
            </div>
            <button className="ghost-btn subtle" onClick={onClose} aria-label="Close create modal">
              ✕
            </button>
          </header>

          <div className="create-grid">
            {CREATE_OPTIONS.map((option) => (
              <CreateCard key={option.key} option={option} selected={selectedKey === option.key} onSelect={onSelect} />
            ))}
          </div>

          <footer className="create-modal__footer">
            <button className="ghost-btn subtle wide" onClick={onClose}>
              Cancel
            </button>
            <button className="primary-btn wide" onClick={handleCreate} disabled={!selectedKey}>
              Create
            </button>
          </footer>
        </div>
        {sideContent}
      </div>
    </div>
  );
}

export default CreateModal;
